<template>
  <a-modal
    :body-style="bodyStyle"
    :visible="modalVisible"
    @cancel="modalCancel"
    @ok="modalSubmit"
    width="50%"
    cancelText="取消"
    okText="确认"
    :title="!modalType ? '创建配置' : modalType === 1 ? '编辑配置' : '配置详情'"
  >
    <a-form
      ref="formRef"
      :model="form"
      :label-col="{ span: 6 }"
      :wrapper-col="{ span: 16 }"
      :rules="rules"
    >
      <div style="font-size: 18px;margin-left: 8%;margin-bottom: 2%;">
        SDK样式配置
      </div>

      <a-form-item label="名称">
        <a-button
          type="dashed"
          block
          @click="addNameContent"
          style="width: 120px;"
        >
          <PlusOutlined />
        </a-button>
      </a-form-item>
      <a-form-item label="说明">
        <a-space
          v-for="(item, index) in form.taskUiName"
          :key="index"
          style="display: flex; margin-bottom: 8px"
          align="baseline"
        >
          <a-form-item
            :name="['taskUiName', index, 'key']"
            label="语言"
            :rules="{
              required: true,
              message: '请选择语言'
            }"
          >
            <a-select
              v-model:value="item.key"
              :options="langList"
              placeholder="请选择"
              @change="changeTaskUiName"
            >
            </a-select>
          </a-form-item>
          <a-form-item
            label="名称"
            :name="['taskUiName', index, 'value']"
            :rules="{
              required: true,
              message: '请输入名称'
            }"
          >
            <a-textarea
              v-model:value="item.value"
              placeholder="请输入名称"
              auto-size
            />
          </a-form-item>

          <MinusCircleOutlined @click="removeNameContent(item)" />
        </a-space>
      </a-form-item>

      <a-form-item label="任务分类" name="taskCategory">
        <a-select
          v-model:value="form.taskCategory"
          placeholder="请选择"
          show-search
          optionFilterProp="label"
          style="width: 300px;"
          allow-clear
          @change="selectTypeTwo"
        >
          <a-select-option
            v-for="(item, index) in assortSelect"
            :key="index"
            :value="item['taskCategoryId']"
            :label="item['taskCategoryName']"
          >
            {{ item['taskCategoryName'] }}
          </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="终端" name="uiTerminal">
        <p v-if="modalType === 2">
          <a-badge :text="uiTerminalOps[form.uiTerminal]" />
        </p>
        <a-radio-group
          v-model:value="form.uiTerminal"
          v-else
          @change="selectType"
        >
          <a-radio :value="1">web</a-radio>
          <a-radio :value="2">app</a-radio>
          <a-radio :value="0">all</a-radio>
        </a-radio-group>
      </a-form-item>
      <a-form-item label="任务类型" name="taskType">
        <a-radio-group v-model:value="form.taskType">
          <a-radio :value="1">浏览任务</a-radio>
        </a-radio-group>
      </a-form-item>
      <a-form-item label="任务" name="taskId">
        <a-select
          v-model:value="form.taskId"
          placeholder="请选择"
          show-search
          optionFilterProp="label"
          allow-clear
          style="width: 300px;"
        >
          <a-select-option
            v-for="(item, index) in taskSelect"
            :key="index"
            :value="item['taskId']"
            :label="item['oneTaskName']"
          >
            {{ item['oneTaskName'] }}
          </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="展示类型" name="showType">
        <a-radio-group v-model:value="form.showType">
          <a-radio :value="1">icon</a-radio>
          <!-- <a-radio :value="2">banner</a-radio> -->
        </a-radio-group>
      </a-form-item>
      <div style="font-size: 18px;margin-left: 11%;margin-bottom: 2%;">
        开始状态
      </div>
      <!-- <a-form-item label="图片" name="bgUrl" v-if="form.showType == 2">
        <UploadBgImg
          v-if="modalVisible"
          :imageType="imageType2"
          :defaultUrl="form.bgUrl"
          @setBgUrl="setBgUrl"
          @delBgImg="delBgImg"
        ></UploadBgImg>
      </a-form-item> -->
      <a-form-item label="图片">
        <a-row>
          <a-col :span="7" v-if="form.uiTerminal == 1 || form.uiTerminal == 0">
            <UpdateImage
              v-if="modalVisible"
              :imageType="imageType1"
              :defaultUrl="form.uiStartWebUrl"
              @setFaceUrl="setFaceUrl"
              @delFaceImg="delFaceImg"
            ></UpdateImage>
          </a-col>
          <a-col :span="7" v-if="form.uiTerminal == 2 || form.uiTerminal == 0">
            <UpdateImage
              v-if="modalVisible"
              :imageType="imageType2"
              :defaultUrl="form.uiStartAppUrl"
              @setFaceUrl="setFaceUrlTwo"
              @delFaceImg="delFaceImgTwo"
            ></UpdateImage>
          </a-col>
        </a-row>
      </a-form-item>
      <!-- <a-form-item label="文案" name="startCopywriting">
        <a-textarea
          v-model:value="form.startCopywriting"
          placeholder="请输入展示文案"
          style="width: 300px;"
          auto-size
        />
      </a-form-item> -->
      <!-- <a-form-item
        label="倒计时展示位置"
        name="displayLocation"
        v-if="form.showType == 1"
      >
        <a-radio-group v-model:value="form.displayLocation">
          <a-radio :value="1">图片内</a-radio>
          <a-radio :value="2">文案内</a-radio>
        </a-radio-group>
      </a-form-item> -->
      <!-- <a-form-item
        label="文案同步展示在banner内"
        name="startSynchronous"
        v-if="form.showType == 2"
        required
      >
        <a-switch
          v-model:checked="form.startSynchronous"
          :checkedValue="1"
          :unCheckedValue="0"
          checked-children="开"
          un-checked-children="关"
        />
        <div style="margin-top: 1%;font-size: 11px;color: rgb(170, 169, 169);">
          ( 开启后设计banner图时需预留位置，位置见样图 )
        </div>
      </a-form-item> -->
      <div style="font-size: 18px;margin-left: 11%;margin-bottom: 2%;">
        达成状态
      </div>
      <!-- <a-form-item label="图片" name="bgUrlTwo" v-if="form.showType == 2">
        <UploadBgImg
          v-if="modalVisible"
          :imageType="imageType2"
          :defaultUrl="form.bgUrlTwo"
          @setBgUrl="setBgUrlTwo"
          @delBgImg="delBgImgTwo"
        ></UploadBgImg>
      </a-form-item> -->
      <a-form-item label="图片">
        <a-row>
          <a-col :span="7" v-if="form.uiTerminal == 1 || form.uiTerminal == 0">
            <UpdateImage
              v-if="modalVisible"
              :imageType="imageType1"
              :defaultUrl="form.uiEndWebUrl"
              @setFaceUrl="setFaceUrlThree"
              @delFaceImg="delFaceImgThree"
            ></UpdateImage>
          </a-col>
          <a-col :span="7" v-if="form.uiTerminal == 2 || form.uiTerminal == 0">
            <UpdateImage
              v-if="modalVisible"
              :imageType="imageType2"
              :defaultUrl="form.uiEndAppUrl"
              @setFaceUrl="setFaceUrlFour"
              @delFaceImg="delFaceImgFour"
            ></UpdateImage>
          </a-col>
        </a-row>
      </a-form-item>
      <a-form-item label="文案">
        <a-button type="dashed" block @click="addContent" style="width: 120px;">
          <PlusOutlined />
        </a-button>
      </a-form-item>
      <a-form-item label="说明">
        <a-space
          v-for="(item, index) in form.uiDesc"
          :key="index"
          style="display: flex; margin-bottom: 8px"
          align="baseline"
        >
          <a-form-item
            :name="['uiDesc', index, 'key']"
            label="语言"
            :rules="{
              required: true,
              message: '请选择语言'
            }"
          >
            <a-select
              v-model:value="item.key"
              :options="langList"
              placeholder="请选择"
              @change="changeUiDesc"
            >
            </a-select>
          </a-form-item>
          <a-form-item
            label="文案"
            :name="['uiDesc', index, 'value']"
            :rules="{
              required: true,
              message: '请输入文案'
            }"
          >
            <a-textarea
              v-model:value="item.value"
              placeholder="请输入文案"
              auto-size
            />
          </a-form-item>

          <MinusCircleOutlined @click="removeContent(item)" />
        </a-space>
      </a-form-item>
      <!-- <a-form-item label="文案" name="endCopywriting">
        <a-textarea
          v-model:value="form.endCopywriting"
          placeholder="请输入展示文案"
          style="width: 300px;"
          auto-size
        />
      </a-form-item> -->
      <!-- <a-form-item
        label="文案同步展示在banner内"
        name="endSynchronous"
        v-if="form.showType == 2"
        required
      >
        <a-switch
          v-model:checked="form.endSynchronous"
          :checkedValue="1"
          :unCheckedValue="0"
          checked-children="开"
          un-checked-children="关"
        />
        <div style="margin-top: 1%;font-size: 11px;color: rgb(170, 169, 169);">
          ( 开启后设计banner图时需预留位置，位置见样图 )
        </div>
      </a-form-item> -->
    </a-form>
  </a-modal>
</template>

<script>
import { inject, toRefs } from 'vue'
import UpdateImage from './UploadImg.vue'
import { MinusCircleOutlined, PlusOutlined } from '@ant-design/icons-vue'
// import UploadBgImg from './UploadBgImg.vue'
export default {
  components: {
    UpdateImage,
    // UploadBgImg
    PlusOutlined,
    MinusCircleOutlined
  },
  setup() {
    return {
      ...toRefs(inject('initState'))
    }
  }
}
</script>

<style lang="scss" scoped>
.ant-input[disabled] {
  color: #000;
}
.item {
  text-align: center;
  border: 1px solid #dedede;
  .label {
    padding: 10px 15px;
    white-space: nowrap;
  }
  .value {
    height: 100%;
    white-space: nowrap;
    padding: 10px 15px;
    border-top: 1px solid #dedede;
    .ant-form-item {
      margin: 0;
    }
  }
}
</style>
